<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"

// ================================
// TYPES & INTERFACES
// ================================
type TimelineStatus = "current" | "completed" | "disabled"

interface TimelineStep {
    label: string
    status: TimelineStatus
}

/** Entrée du modèle PrimeVue {@link BaseSteps} */
interface StepsModelItem {
    label: string
    disabled: boolean
}

// ================================
// PROPS
// ================================
const props = withDefaults(
    defineProps<{
        hideTimeline?: boolean
        timeline?: TimelineStep[]
    }>(),
    {
        hideTimeline: false,
        timeline: () => [],
    }
)

// ================================
// COMPUTED
// ================================
const getStepsModel = computed((): StepsModelItem[] => {
    return props.timeline.map((s) => ({
        label: s.label,
        disabled: s.status === "disabled",
    }))
})

const getActiveStepIndex = computed((): number => {
    const i = props.timeline.findIndex((s) => s.status === "current")
    if (i >= 0) return i
    const lastCompleted = [...props.timeline]
        .map((s, index) => ({ s, index }))
        .filter(({ s }) => s.status === "completed")
    if (lastCompleted.length > 0) {
        return lastCompleted[lastCompleted.length - 1].index
    }
    return 0
})
</script>

<template>
    <section class="pv-form-container flex w-full flex-col items-center gap-8">
        <BaseSteps
            v-if="!hideTimeline && getStepsModel.length > 0"
            :model="getStepsModel"
            :active-step="getActiveStepIndex"
            readonly
            class="w-full"
        />
        <slot />
    </section>
</template>
